export enum ANNOTATION_DETACHED_REASON {
    quoteRemoved = 'quote-removed',
    quoteAmbiguous = 'quote-ambiguous',
}
